module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pleaseWait":"One moment please..."},"de":{"pleaseWait":"Einen Moment bitte..."},"fr":{"pleaseWait":"Un moment, s\u0027il vous plaît..."},"it":{"pleaseWait":"Un momento per favore..."}}')
  delete Component.options._Ctor
}
